import { render, staticRenderFns } from "./tabTotalGaji.vue?vue&type=template&id=354d65ee"
import script from "./tabTotalGaji.vue?vue&type=script&lang=js"
export * from "./tabTotalGaji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports